import { Injectable } from '@angular/core';
import {
    INotesComponent,
    INotesSection
} from '@modeso/types__aumico-lib-annualreport-be';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class NotesVisibilityHelper {
    public removeHiddenNotes(accordions: INotesSection[]): INotesSection[] {
        const accordionsWithRemovedHiddenNotes: INotesSection[] = [];

        for (const accordion of accordions) {
            if (!accordion) {
                continue;
            }
            const accordionWithRemovedHiddenNotes = this.removeHiddenNotesOfAccordion(accordion);
            if (!accordionWithRemovedHiddenNotes) {
                continue;
            }
            const isAccordionEmptyOfComponents = accordionWithRemovedHiddenNotes.data.length === 0;

            if (isAccordionEmptyOfComponents) {
                continue;
            }

            accordionsWithRemovedHiddenNotes.push(accordionWithRemovedHiddenNotes);
        }

        return accordionsWithRemovedHiddenNotes;
    }

    private removeHiddenNotesOfAccordion(accordion: INotesSection): INotesSection | undefined {
        let accordionWithRemovedHiddenNotes: INotesSection | undefined;
        const accordionDataWithRemovedHiddenNotes: INotesComponent[] = [];

        for (const accordionData of accordion.data) {
            if (!accordionData) {
                continue;
            }

            const isComponentHidden = this.isComponentHidden(accordionData);
            if (isComponentHidden) {
                continue;
            }

            accordionDataWithRemovedHiddenNotes.push({
                componentName: accordionData.componentName,
                componentTitle: accordionData.componentTitle,
                componentId: accordionData.componentId,
                data: accordionData.data,
                addNumbering: accordionData.addNumbering,
                referenceFlis: accordionData.referenceFlis,
                hasFootnotes: accordionData.hasFootnotes,
            });
        }

        if (accordionDataWithRemovedHiddenNotes.length > 0) {
            accordionWithRemovedHiddenNotes = cloneDeep<INotesSection>(accordion);
            accordionWithRemovedHiddenNotes.data = accordionDataWithRemovedHiddenNotes;
        }

        return accordionWithRemovedHiddenNotes;
    }

    private isComponentHidden(component: INotesComponent): boolean {
        return component.isHidden === true;
    }
}
